import { z } from 'zod'

export const RepairSubmissionVerdictSchema = z.object({
  approved: z.boolean(), assessment: z.string().min(1), problems: z.array(z.string()),
  inconclusive: z.boolean().optional(),
}).strict()
export const PreparedRepairSchema = z.object({
  hash: z.string(), before: z.unknown(), after: z.unknown(),
}).strict()
export const RepairSubmissionApprovalSchema = z.object({
  hash: z.string(), verdict: RepairSubmissionVerdictSchema,
}).strict()
export function assertRepairApproval(raw: unknown, hash: string) {
  const approval = RepairSubmissionApprovalSchema.parse(raw)
  if (approval.hash !== hash || !approval.verdict.approved || approval.verdict.inconclusive || approval.verdict.problems.length > 0) {
    throw new Error('Repair requires judge approval of the exact current proposal and staged contents')
  }
}

const ObjectValue = z.record(z.unknown())
const ArrayValue = z.array(z.unknown())
/** Lossless changed subtrees keep large unchanged project maps out of the judge context. */
export function repairReviewChanges(before: unknown, after: unknown, path: (string | number)[] = []): { path: (string | number)[]; before?: unknown; after?: unknown }[] {
  if (JSON.stringify(before) === JSON.stringify(after)) return []
  const a = ObjectValue.safeParse(before), b = ObjectValue.safeParse(after)
  if (a.success && b.success) return [...new Set([...Object.keys(a.data), ...Object.keys(b.data)])]
    .flatMap(key => repairReviewChanges(a.data[key], b.data[key], [...path, key]))
  const aa = ArrayValue.safeParse(before), bb = ArrayValue.safeParse(after)
  if (aa.success && bb.success) return Array.from({ length: Math.max(aa.data.length, bb.data.length) }, (_, index) => index)
    .flatMap(index => repairReviewChanges(aa.data[index], bb.data[index], [...path, index]))
  return [{ path, before, after }]
}
